export var IDENTIFIER_ICON = 'icon';
export var E_ICONS;
(function (E_ICONS) {
    E_ICONS[E_ICONS["ADD"] = 0] = "ADD";
    E_ICONS[E_ICONS["ARROW_LEFT"] = 1] = "ARROW_LEFT";
    E_ICONS[E_ICONS["ARROW_RIGHT"] = 2] = "ARROW_RIGHT";
    E_ICONS[E_ICONS["BRIEFCASE"] = 3] = "BRIEFCASE";
    E_ICONS[E_ICONS["CALENDAR"] = 4] = "CALENDAR";
    E_ICONS[E_ICONS["CHAT"] = 5] = "CHAT";
    E_ICONS[E_ICONS["CHECK"] = 6] = "CHECK";
    E_ICONS[E_ICONS["CHECK_CIRCLE"] = 7] = "CHECK_CIRCLE";
    E_ICONS[E_ICONS["CLOSE"] = 8] = "CLOSE";
    E_ICONS[E_ICONS["CLOSE_CIRCLE"] = 9] = "CLOSE_CIRCLE";
    E_ICONS[E_ICONS["CNI_ICON"] = 10] = "CNI_ICON";
    E_ICONS[E_ICONS["COLUMNS"] = 11] = "COLUMNS";
    E_ICONS[E_ICONS["COPY"] = 12] = "COPY";
    E_ICONS[E_ICONS["CSV"] = 13] = "CSV";
    E_ICONS[E_ICONS["DOWNLOAD"] = 14] = "DOWNLOAD";
    E_ICONS[E_ICONS["EDIT"] = 15] = "EDIT";
    E_ICONS[E_ICONS["EMPTY_BOLT"] = 16] = "EMPTY_BOLT";
    E_ICONS[E_ICONS["EXCHANGE"] = 17] = "EXCHANGE";
    E_ICONS[E_ICONS["EXPORT"] = 18] = "EXPORT";
    E_ICONS[E_ICONS["FILTER"] = 19] = "FILTER";
    E_ICONS[E_ICONS["FOLDER"] = 20] = "FOLDER";
    E_ICONS[E_ICONS["FULL_ARROW_RIGHT"] = 21] = "FULL_ARROW_RIGHT";
    E_ICONS[E_ICONS["FULL_BOLT"] = 22] = "FULL_BOLT";
    E_ICONS[E_ICONS["FULLSCREEN"] = 23] = "FULLSCREEN";
    E_ICONS[E_ICONS["FULLSCREEN_EXIT"] = 24] = "FULLSCREEN_EXIT";
    E_ICONS[E_ICONS["GROUP"] = 25] = "GROUP";
    E_ICONS[E_ICONS["HEART_PULSE"] = 26] = "HEART_PULSE";
    E_ICONS[E_ICONS["HISTORY"] = 27] = "HISTORY";
    E_ICONS[E_ICONS["IDENTITY_FRAUD"] = 28] = "IDENTITY_FRAUD";
    E_ICONS[E_ICONS["IDENTITY_INCOMPLETED"] = 29] = "IDENTITY_INCOMPLETED";
    E_ICONS[E_ICONS["IDENTITY_NEVER_COMPLETED"] = 30] = "IDENTITY_NEVER_COMPLETED";
    E_ICONS[E_ICONS["IDENTITY_TO_STUDY"] = 31] = "IDENTITY_TO_STUDY";
    E_ICONS[E_ICONS["IDENTITY_VALID"] = 32] = "IDENTITY_VALID";
    E_ICONS[E_ICONS["INFO"] = 33] = "INFO";
    E_ICONS[E_ICONS["INFORMATION"] = 34] = "INFORMATION";
    E_ICONS[E_ICONS["LOCK"] = 35] = "LOCK";
    E_ICONS[E_ICONS["LOGOUT"] = 36] = "LOGOUT";
    E_ICONS[E_ICONS["MESSAGE"] = 37] = "MESSAGE";
    E_ICONS[E_ICONS["MORE"] = 38] = "MORE";
    E_ICONS[E_ICONS["NOTIFICATION_OFF"] = 39] = "NOTIFICATION_OFF";
    E_ICONS[E_ICONS["NOTIFICATION_ON"] = 40] = "NOTIFICATION_ON";
    E_ICONS[E_ICONS["PDF"] = 41] = "PDF";
    E_ICONS[E_ICONS["PICTURE"] = 42] = "PICTURE";
    E_ICONS[E_ICONS["PLAY"] = 43] = "PLAY";
    E_ICONS[E_ICONS["PAUSE"] = 44] = "PAUSE";
    E_ICONS[E_ICONS["QUESTION"] = 45] = "QUESTION";
    E_ICONS[E_ICONS["QUESTION_CIRCLE"] = 46] = "QUESTION_CIRCLE";
    E_ICONS[E_ICONS["QUICKSIGN"] = 47] = "QUICKSIGN";
    E_ICONS[E_ICONS["REFRESH"] = 48] = "REFRESH";
    E_ICONS[E_ICONS["ROLLBACK"] = 49] = "ROLLBACK";
    E_ICONS[E_ICONS["ROTATE_LEFT"] = 50] = "ROTATE_LEFT";
    E_ICONS[E_ICONS["ROTATE_RIGHT"] = 51] = "ROTATE_RIGHT";
    E_ICONS[E_ICONS["SEARCH"] = 52] = "SEARCH";
    E_ICONS[E_ICONS["SEND"] = 53] = "SEND";
    E_ICONS[E_ICONS["SETTINGS"] = 54] = "SETTINGS";
    E_ICONS[E_ICONS["STATEMENT"] = 55] = "STATEMENT";
    E_ICONS[E_ICONS["SUB"] = 56] = "SUB";
    E_ICONS[E_ICONS["TRASH"] = 57] = "TRASH";
    E_ICONS[E_ICONS["USER"] = 58] = "USER";
    E_ICONS[E_ICONS["WALLET"] = 59] = "WALLET";
    E_ICONS[E_ICONS["WARNING"] = 60] = "WARNING";
    E_ICONS[E_ICONS["ZOOM_IN"] = 61] = "ZOOM_IN";
    E_ICONS[E_ICONS["ZOOM_OUT"] = 62] = "ZOOM_OUT";
})(E_ICONS || (E_ICONS = {}));
